import { takeLatest, all, takeEvery, take } from 'redux-saga/effects'
import { AuthTypes } from '../Stores/Auth/Actions'
import { AdminTypes } from '../Stores/Admin/Actions'
import { UserTypes } from '../Stores/User/Actions'
import { TransactionTypes } from 'Stores/Transaction/Actions'
import { NotificationTypes } from '../Stores/Notification/Actions'
import { VoucherTypes } from '../Stores/Voucher/Actions'
import { RoleTypes } from '../Stores/Role/Actions'
import { CountriesTypes } from 'Stores/Country/Actions'
import { ChargingTokenTypes } from '../Stores/ChargingToken/Actions'
import { ChargingTokenDesignTypes } from '../Stores/ChargingTokenDesign/Actions'
import { AnalyticsTypes } from '../Stores/Analytics/Actions'

import {
  login,
  onTwoFactorVerify,
  getUser,
  logout,
  fetchEditingAdminRole,
  changePassword,
  fetchAdminDetails,
  setCurrentUserNewName,
  fetchAdminActionsList,
  resetPasswordVerification,
  resetPassword,
  onTwoFactorSetupVerify,
} from './AuthSaga'

import {
  fetchAdminList,
  updateAdminRole,
  deleteAdmin,
  unblockAdmin,
  fetchAdminsCount,
  inviteAdmin,
  fetchInviteAdminList,
  deleteInviteAdmin,
  sendAdminEmail,
  fetchInviteAdmin,
  createAdmin,
  fetchAdminsInvitationsCount,
} from './AdminSaga'

import {
  fetchUserList,
  setCurrentUserTransactionRefund,
  setCurrentUserNewBalance,
  setCurrentUserChargingTokenActive,
  addCurrentUserNewCard,
  toggleCurrentUserIsActive,
  fetchUserDetails,
  fetchUserTransactionList,
  setCurrentUserNewPhone,
  fetchUserPoints,
  fetchUserPaymentSessionList,
  deleteCurrentUserPaymentCard,
  fetchAdminActionsUsersList,
  fetchOngoingSessionsList,
  setCurrentUserEmail,
  resendCurrentUserEmailVerification,
  fetchUserNotificationList,
  fetchTransactionTimeline,
} from './UserSaga'

import {
  fetchNotificationGroups,
  fetchNotifications,
  editNotification,
  scheduleNotification,
  fetchGroupsCount,
  fetchNotificationsCount,
  fetchGroups,
  editGroup,
  deleteGroup,
  createGroup,
  fetchQueryCount,
} from './NotificationSaga'
import {
  fetchTransactionsList,
  fetchTransactionsMetrics,
  fetchEnergyConsumptionChart,
  fetchAllSubscriptions,
} from './TransactionSaga'
import {
  fetchVouchers,
  addVoucher,
  updateVoucher,
  deleteVoucher,
  fetchAllVouchers,
} from './VoucherSaga'

import {
  fetchRolesCount,
  updateRole,
  fetchRoles,
  createRole,
  deleteRole,
  fetchRoleAdminList,
  fetchRolesWithAdmins,
  fetchAllRoles,
} from './RoleSaga'

import {
  fetchCountriesList,
  fetchCountriesListCount,
  addCountry,
} from './CountrySaga'

import {
  fetchChargingTokens,
  editChargingToken,
  deleteChargingToken,
  createChargingToken,
  createChargingTokenBulk,
  downloadChargingTokenSampleFile,
  getChargingTokensCount,
} from './ChargingTokenSaga'

import {
  fetchChargingTokenDesigns,
  fetchAllChargingTokenDesigns,
  addChargingTokenDesign,
  editChargingTokenDesign,
  getChargingTokenDesignsCount,
  deleteChargingTokenDesign,
} from './ChargingTokenDesignSaga'
import {
  fetchTopCities,
  fetchPeakHour,
  fetchAverageDuration,
  fetchTopVouchers,
  fetchTopSites,
  fetchOverview,
  fetchTransactionsStatistics,
  fetchUserSignup,
  fetchTopUsers,
  fetchUsersActivity,
  fetchUsersStatistics,
  fetchEnergyChart,
  fetchTimeForFirstCharge,
  fetchTimeBetweenTrans,
  fetchPaymentBreakdown,
} from './AnalyticsSaga'

export default function* root() {
  yield all([
    takeLatest(AuthTypes.FETCH_ADMIN_ACTIONS_LIST, fetchAdminActionsList),
  ])

  yield all([takeLatest(AuthTypes.LOGIN, login)])
  yield all([takeLatest(AuthTypes.ON_TWO_FACTOR_VERIFY, onTwoFactorVerify)])
  yield all([
    takeLatest(AuthTypes.ON_TWO_FACTOR_SETUP_VERIFY, onTwoFactorSetupVerify),
  ])
  yield all([takeLatest(AuthTypes.GET_USER, getUser)])
  yield all([takeLatest(AuthTypes.LOGOUT, logout)])
  yield all([
    takeLatest(AuthTypes.FETCH_EDITING_ADMIN_ROLE, fetchEditingAdminRole),
  ])
  yield all([takeLatest(AuthTypes.CHANGE_PASSWORD, changePassword)])
  yield all([takeLatest(AuthTypes.FETCH_ADMIN_DETAILS, fetchAdminDetails)])
  yield all([
    takeLatest(AuthTypes.SET_CURRENT_USER_NEW_NAME, setCurrentUserNewName),
  ])
  yield all([
    takeLatest(
      AuthTypes.RESET_PASSWORD_VERIFICATION,
      resetPasswordVerification,
    ),
  ])
  yield all([takeLatest(AuthTypes.RESET_PASSWORD, resetPassword)])

  yield all([takeLatest(UserTypes.FETCH_USER_LIST, fetchUserList)])
  yield all([takeLatest(UserTypes.FETCH_USER_DETAILS, fetchUserDetails)])

  yield all([
    takeLatest(
      UserTypes.FETCH_ADMIN_ACTIONS_USERS_LIST,
      fetchAdminActionsUsersList,
    ),
  ])

  yield all([
    takeLatest(UserTypes.FETCH_ONGOING_SESSIONS_LIST, fetchOngoingSessionsList),
  ])

  yield all([
    takeLatest(UserTypes.FETCH_USER_TRANSACTION_LIST, fetchUserTransactionList),
  ])
  yield all([
    takeLatest(
      UserTypes.SET_CURRENT_USER_CHARGING_TOKEN_ACTIVE,
      setCurrentUserChargingTokenActive,
    ),
  ])
  yield all([
    takeLatest(
      UserTypes.SET_CURRENT_USER_TRANSACTION_REFUND,
      setCurrentUserTransactionRefund,
    ),
  ])
  yield all([takeLatest(UserTypes.FETCH_USER_POINTS, fetchUserPoints)])

  yield all([takeLatest(AdminTypes.FETCH_ADMIN_LIST, fetchAdminList)])
  yield all([takeLatest(AdminTypes.FETCH_ADMINS_COUNT, fetchAdminsCount)])

  yield all([takeLatest(AdminTypes.UPDATE_ADMIN_ROLE, updateAdminRole)])
  yield all([takeLatest(AdminTypes.DELETE_ADMIN, deleteAdmin)])
  yield all([takeLatest(AdminTypes.UNBLOCK_ADMIN, unblockAdmin)])
  yield all([takeLatest(AdminTypes.INVITE_ADMIN, inviteAdmin)])
  yield all([takeLatest(AdminTypes.DELETE_INVITE_ADMIN, deleteInviteAdmin)])
  yield all([
    takeLatest(AdminTypes.FETCH_INVITE_ADMIN_LIST, fetchInviteAdminList),
  ])
  yield all([takeLatest(AdminTypes.SEND_ADMIN_EMAIL, sendAdminEmail)])
  yield all([takeLatest(AdminTypes.FETCH_INVITE_ADMIN, fetchInviteAdmin)])
  yield all([takeLatest(AdminTypes.CREATE_ADMIN, createAdmin)])
  yield all([
    takeLatest(
      AdminTypes.FETCH_ADMINS_INVITATIONS_COUNT,
      fetchAdminsInvitationsCount,
    ),
  ])

  yield all([takeLatest(RoleTypes.FETCH_ROLES_COUNT, fetchRolesCount)])
  yield all([takeLatest(RoleTypes.UPDATE_ROLE, updateRole)])
  yield all([takeLatest(RoleTypes.FETCH_ROLES, fetchRoles)])
  yield all([takeLatest(RoleTypes.CREATE_ROLE, createRole)])
  yield all([takeLatest(RoleTypes.DELETE_ROLE, deleteRole)])
  yield all([takeLatest(RoleTypes.FETCH_ROLE_ADMIN_LIST, fetchRoleAdminList)])
  yield all([
    takeLatest(RoleTypes.FETCH_ROLES_WITH_ADMINS, fetchRolesWithAdmins),
  ])
  yield all([takeLatest(RoleTypes.FETCH_ALL_ROLES, fetchAllRoles)])

  yield all([
    takeLatest(UserTypes.ADD_CURRENT_USER_NEW_CARD, addCurrentUserNewCard),
  ])

  yield all([
    takeLatest(
      UserTypes.TOGGLE_CURRENT_USER_IS_ACTIVE,
      toggleCurrentUserIsActive,
    ),
  ])
  yield all([
    takeLatest(
      UserTypes.DELETE_CURRENT_USER_PAYMENT_CARD,
      deleteCurrentUserPaymentCard,
    ),
  ])
  yield all([
    takeLatest(
      UserTypes.SET_CURRENT_USER_NEW_BALANCE,
      setCurrentUserNewBalance,
    ),
  ])

  yield all([
    takeLatest(UserTypes.SET_CURRENT_USER_NEW_PHONE, setCurrentUserNewPhone),
  ])

  yield all([
    takeLatest(UserTypes.SET_CURRENT_USER_EMAIL, setCurrentUserEmail),
  ])
  yield all([
    takeLatest(
      UserTypes.RESEND_CURRENT_USER_EMAIL_VERIFICATION,
      resendCurrentUserEmailVerification,
    ),
  ])
  yield all([
    takeLatest(
      UserTypes.FETCH_USER_NOTIFICATION_LIST,
      fetchUserNotificationList,
    ),
  ])
  yield all([
    takeLatest(
      UserTypes.FETCH_TRANSACTION_TIMELINE,
      fetchTransactionTimeline,
    ),
  ])

  yield all([
    takeLatest(
      NotificationTypes.FETCH_NOTIFICATION_GROUPS,
      fetchNotificationGroups,
    ),
  ])
  yield all([
    takeLatest(NotificationTypes.FETCH_NOTIFICATIONS, fetchNotifications),
  ])
  yield all([takeLatest(NotificationTypes.EDIT_NOTIFICATION, editNotification)])
  yield all([
    takeLatest(NotificationTypes.SCHEDULE_NOTIFICATION, scheduleNotification),
  ])
  yield all([
    takeLatest(
      NotificationTypes.FETCH_NOTIFICATIONS_COUNT,
      fetchNotificationsCount,
    ),
  ])
  yield all([
    takeLatest(NotificationTypes.FETCH_GROUPS_COUNT, fetchGroupsCount),
  ])
  yield all([takeLatest(NotificationTypes.FETCH_GROUPS, fetchGroups)])
  yield all([takeLatest(NotificationTypes.EDIT_GROUP, editGroup)])
  yield all([takeLatest(NotificationTypes.DELETE_GROUP, deleteGroup)])
  yield all([takeLatest(NotificationTypes.CREATE_GROUP, createGroup)])
  yield all([takeLatest(NotificationTypes.FETCH_QUERY_COUNT, fetchQueryCount)])

  yield all([
    takeLatest(TransactionTypes.FETCH_TRANSACTIONS_LIST, fetchTransactionsList),
  ])

  yield all([
    takeLatest(
      TransactionTypes.FETCH_TRANSACTIONS_METRICS,
      fetchTransactionsMetrics,
    ),
  ])
  yield all([
    takeLatest(
      TransactionTypes.FETCH_ENERGY_CONSUMPTION_CHART,
      fetchEnergyConsumptionChart,
    ),
  ])

  yield all([takeLatest(VoucherTypes.FETCH_VOUCHERS, fetchVouchers)])

  yield all([takeLatest(VoucherTypes.ADD_VOUCHER, addVoucher)])

  yield all([takeEvery(VoucherTypes.UPDATE_VOUCHER, updateVoucher)])
  yield all([takeEvery(VoucherTypes.DELETE_VOUCHER, deleteVoucher)])
  yield all([takeLatest(VoucherTypes.FETCH_ALL_VOUCHERS, fetchAllVouchers)])

  yield all([
    takeLatest(
      UserTypes.FETCH_USER_PAYMENT_SESSION_LIST,
      fetchUserPaymentSessionList,
    ),
  ])
  yield all([
    takeLatest(
      CountriesTypes.FETCH_COUNTRIES_LIST_COUNT,
      fetchCountriesListCount,
    ),
  ])
  yield all([
    takeLatest(CountriesTypes.FETCH_COUNTRIES_LIST, fetchCountriesList),
  ])
  yield all([takeLatest(CountriesTypes.ADD_COUNTRY, addCountry)])

  yield all([
    takeLatest(TransactionTypes.FETCH_ALL_SUBSCRIPTIONS, fetchAllSubscriptions),
  ])

  yield all([
    takeLatest(ChargingTokenTypes.FETCH_CHARGING_TOKENS, fetchChargingTokens),
  ])
  yield all([
    takeLatest(ChargingTokenTypes.EDIT_CHARGING_TOKEN, editChargingToken),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.FETCH_CHARGING_TOKEN_DESIGNS,
      fetchChargingTokenDesigns,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.FETCH_ALL_CHARGING_TOKEN_DESIGNS,
      fetchAllChargingTokenDesigns,
    ),
  ])
  yield all([
    takeLatest(ChargingTokenTypes.DELETE_CHARGING_TOKEN, deleteChargingToken),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.ADD_CHARGING_TOKEN_DESIGN,
      addChargingTokenDesign,
    ),
  ])
  yield all([
    takeLatest(ChargingTokenTypes.CREATE_CHARGING_TOKEN, createChargingToken),
  ])
  yield all([
    takeLatest(
      ChargingTokenTypes.CREATE_CHARGING_TOKEN_BULK,
      createChargingTokenBulk,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenTypes.DOWNLOAD_CHARGING_TOKEN_SAMPLE_FILE,
      downloadChargingTokenSampleFile,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenTypes.GET_CHARGING_TOKENS_COUNT,
      getChargingTokensCount,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.DELETE_CHARGING_TOKEN_DESIGN,
      deleteChargingTokenDesign,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.GET_CHARGING_TOKEN_DESIGNS_COUNT,
      getChargingTokenDesignsCount,
    ),
  ])
  yield all([
    takeLatest(
      ChargingTokenDesignTypes.EDIT_CHARGING_TOKEN_DESIGN,
      editChargingTokenDesign,
    ),
  ])

  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_CITIES, fetchTopCities)])
  yield all([takeLatest(AnalyticsTypes.FETCH_PEAK_HOUR, fetchPeakHour)])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_AVERAGE_DURATION, fetchAverageDuration),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_VOUCHERS, fetchTopVouchers)])
  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_SITES, fetchTopSites)])
  yield all([takeLatest(AnalyticsTypes.FETCH_OVERVIEW, fetchOverview)])
  yield all([
    takeLatest(
      AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS,
      fetchTransactionsStatistics,
    ),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_USER_SIGNUP, fetchUserSignup)])
  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_USERS, fetchTopUsers)])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_USERS_ACTIVITY, fetchUsersActivity),
  ])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_USERS_STATISTICS, fetchUsersStatistics),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_ENERGY_CHART, fetchEnergyChart)])
  yield all([
    takeLatest(
      AnalyticsTypes.FETCH_TIME_FOR_FIRST_CHARGE,
      fetchTimeForFirstCharge,
    ),
  ])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_TIME_BETWEEN_TRANS, fetchTimeBetweenTrans),
  ])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_PAYMENT_BREAKDOWN, fetchPaymentBreakdown),
  ])
}
